// §video-visit — let the patient choose an online (async) or video visit with
// the doctor at checkout. Beluga offers video for every visit type (owner,
// 2026-10-21); spec: super-admin repo memory/
// BACKEND_INTAKE_BELUGA_VIDEO_VISIT_OPTION_2026_10_21_PRD.md.
//
// The BE decides per visitType + state via GET /intake/visit-modality →
// { modality: 'optional'|'required'|'unavailable', priceDeltaCents }.
//   optional    → both choices, online preselected
//   required    → video, locked (TRT / sync-state weight loss today)
//   unavailable → no choice rendered, nothing sent
// Any failure (404 until the BE ships, network, bad shape) is 'unavailable', so
// nobody can pick video and silently get an async visit.
//
// MONEY: a non-zero priceDeltaCents is also treated as 'unavailable' for now.
// Every checkout's summary shows its own total; adding a video surcharge only to
// the Square charge would display one number and charge another, and any price
// change needs the owner's sign-off first. Wire the delta through the summaries
// when that happens.

export const MODALITY_ASYNC = 'async';
export const MODALITY_VIDEO = 'video';

const UNAVAILABLE = Object.freeze({ modality: 'unavailable', priceDeltaCents: 0 });

/**
 * Normalise a GET /intake/visit-modality response. Anything unexpected →
 * unavailable.
 */
export function normalizeModalityConfig(data) {
  const modality = data && data.modality;
  if (modality !== 'optional' && modality !== 'required') return UNAVAILABLE;
  const delta = Number(data.priceDeltaCents || 0);
  if (!Number.isFinite(delta) || delta !== 0) return UNAVAILABLE;
  return { modality, priceDeltaCents: 0, reason: typeof data.reason === 'string' ? data.reason : '' };
}

/**
 * The patient's state for the lookup, from whichever answer the flow uses.
 */
export function modalityStateFromAnswers(answers) {
  const a = answers || {};
  const raw =
    (a['shipping-address'] && a['shipping-address'].state) ||
    a['state-of-residence'] ||
    (a['basic-contact'] && a['basic-contact'].state) ||
    '';
  return String(raw).trim().toUpperCase();
}

// The choice made on this page. One intake per page load, so module state is
// enough; the visit-create calls in services/api.js read it.
let chosen = null;

/** Record what the patient will get, or null when no choice was offered. */
export function setChosenVisitModality(value) {
  chosen = value === MODALITY_VIDEO || value === MODALITY_ASYNC ? value : null;
}

/** 'async' | 'video' when the choice was offered, else null (send nothing). */
export function getChosenVisitModality() {
  return chosen;
}
